import { render, staticRenderFns } from "./WhatIfSlide.vue?vue&type=template&id=7ce7f4de"
import script from "./WhatIfSlide.vue?vue&type=script&lang=js"
export * from "./WhatIfSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce7f4de')) {
      api.createRecord('7ce7f4de', component.options)
    } else {
      api.reload('7ce7f4de', component.options)
    }
    module.hot.accept("./WhatIfSlide.vue?vue&type=template&id=7ce7f4de", function () {
      api.rerender('7ce7f4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/WhatIfSlide.vue"
export default component.exports